import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import LogoUploadBox from '@/modules/client-setting/components/GeneralSetting/components/LogoUploadBox'
import FaviconUploadBox from '@/modules/client-setting/components/GeneralSetting/components/FaviconUploadBox'
import CssUploadBox from '@/modules/client-setting/components/GeneralSetting/components/CssUploadBox'
import FontFamilyInput from '@/modules/client-setting/components/GeneralSetting/components/FontFamilyInput'
import ThemePresetSelector from '@/modules/client-setting/components/ThemePresetSelector'
import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import { Label } from '@/common/ui/label'
import { ShowDropShadow } from '@/modules/client-setting/components/GeneralSetting/components/GeneralSettingBox/components/ShowDropShadow'
import useQueryGetGeneralSetting from '@/modules/client-setting/api/hooks/useQueryGetGeneralSetting'

export default function WebsiteBrandingListing() {
	const projectName = import.meta.env.VITE_PROJECT_NAME || 'default'
	const { data: generalSetting } = useQueryGetGeneralSetting()

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ตั้งค่าแบรนด์เว็บไซต์"
					description="จัดการโลโก้ Favicon และธีมสีของเว็บไซต์"
				/>
			</div>
			<Separator />
			<LogoUploadBox projectName={projectName} />
			<FaviconUploadBox projectName={projectName} />
			<ThemePresetSelector />
			<CssUploadBox projectName={projectName} />
			{generalSetting && <FontFamilyInput data={generalSetting} />}
			{generalSetting && (
				<Card>
					<CardHeader className="pb-4">
						<CardTitle className="text-lg">ตั้งค่าภาพเว็บไซต์</CardTitle>
					</CardHeader>
					<CardContent>
						<div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between sm:p-4">
							<div className="space-y-0.5">
								<Label className="text-sm sm:text-base">
									แสดง Drop Shadow Effect
								</Label>
								<p className="text-xs text-muted-foreground">
									เมื่อเปิดใช้งาน จะแสดง gradient glow effects ในหน้าผู้เล่น
									(เช่น เอฟเฟกต์ rank, nav items)
								</p>
							</div>
							<ShowDropShadow data={generalSetting} />
						</div>
					</CardContent>
				</Card>
			)}
		</div>
	)
}
